<script lang="ts">
  import { APP_CONSTANTS } from '../../../common/config/app-constants';
  import { isMobileWidth } from '../../../common/util';
  import { openHomeMaintenanceDialog } from '../service/home-maintenance-data-services';

  export let data;
  export let serviceTitle: string;
  const isResponsive = isMobileWidth();
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="service-card" on:click={openHomeMaintenanceDialog(data?.categoryId, serviceTitle)}>
  <div class="image-wrapper">
    <img
      src={`${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}${data?.id}?fmt=auto&w=${isResponsive ? 220 : 742}&h=${isResponsive ? 196 : 658}&sm=c`}
      alt={data?.title}
    />
  </div>
</div>
<p class="service-title">{data?.title}</p>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .service-card {
    width: 371px;
    height: 329px;
    border-radius: 20px;
    cursor: pointer;
    text-align: center;
    border: 1px solid $secondary-gray-02;
    @include desktop-max-width {
      width: 110px;
      height: 98px;
      border-radius: 15px;
      // flex: 0 0 110px;
    }
  }

  .image-wrapper {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    overflow: hidden;
    background-color: #f2f2f2;
  }

  .service-title {
    margin-top: 8px;
    font-weight: 500;
    font-size: 28px;
    line-height: 30px;
    margin-bottom: 0;
    text-align: center;
    @include desktop-max-width {
      font-size: 12px;
      line-height: 16px;
    }
  }
</style>
